import { makeObservable } from 'mobx'
import { AbstractLabel } from '@core/models/abstractLabel'

export class AbstractLabelObservable<T = number> extends AbstractLabel<T> {
  constructor(data: any = null) {
    super(data)
    makeObservable(this)
  }
}
